import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UsuarioService } from '@shared/services/usuario/usuario.service';
import { NotificationService } from '@shared/services/notificacion/notification.service';
import { map, take } from 'rxjs/operators';

/**
 * Guard que protege rutas exclusivas del sistema.
 * Permite acceso SOLO a usuarios con rol SUPERADMIN.
 */
export const superadminGuard: CanActivateFn = (route, state) => {
  const usuarioService = inject(UsuarioService);
  const router = inject(Router);
  const notification = inject(NotificationService);

  // Si el perfil ya está cargado en el signal
  const perfil = usuarioService.perfil();
  
  if (perfil) {
    const roleName    = perfil?.role?.name;
    const companyType = perfil?.companyType ?? '';
    
    // Solo SUPERADMIN del PROVIDER puede acceder
    if (companyType === 'PROVIDER' && roleName === 'SUPERADMIN') {
      return true;
    }
    
    // Acceso denegado
    notification.danger(
      'Acceso Denegado', 
      'Esta sección es exclusiva para Super Administradores.'
    );
    router.navigate(['/dashboard/obras']);
    return false;
  }

  // Si no está cargado, intentar obtener el perfil
  return usuarioService.getPerfil().pipe(
    take(1),
    map((perfilData) => {
      const roleName    = perfilData?.role?.name;
      const companyType = perfilData?.companyType ?? '';
      
      if (companyType === 'PROVIDER' && roleName === 'SUPERADMIN') {
        return true;
      }
      
      notification.danger(
        'Acceso Denegado', 
        'Esta sección es exclusiva para Super Administradores.'
      );
      router.navigate(['/dashboard/obras']);
      return false;
    })
  );
};
